module.exports = __webpack_public_path__ + "img/dropdown-icon.ef9167d4.svg";